import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { useAuth } from '@backrs_ui/grow-ui/src/hooks/useAuth';

type ProtectedRouteProps = Readonly<{
  children: ReactElement;
}>;

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { loggedIn } = useAuth();

  if (loggedIn) {
    return children;
  }

  return <Navigate to={APP_ROUTE.LOGIN} replace />;
};
